import React, { useContext } from 'react';
import { ToggleButton } from '@/shared/ToggleButton';
import { ExportContext } from '../ExportCompound.context';

export const GraphicsMapToggle = (): React.ReactNode => {
  const { setGraphicsMapToggle, data } = useContext(ExportContext);

  return (
    <div>
      <ToggleButton
        id="format-type"
        isChecked={data.graphicsMapToggle}
        onToggle={value => setGraphicsMapToggle(value)}
        labelTrue="Source"
        labelFalse="Image"
        className="w-32"
      />
    </div>
  );
};
